import React from "react";
import { useParams, Redirect } from "react-router-dom";
import { Helmet } from "react-helmet";
import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";
import DestinationPage from "../components/Destinations/DestinationPage";
import { DESTINATIONS } from "../data/destinations";

const DestinationContainer = () => {
  const { slug } = useParams();
  const data = DESTINATIONS[slug];

  if (!data) {
    return <Redirect to="/" />;
  }

  return (
    <div>
      <Helmet>
        <title>{data.title}</title>
        <meta name="description" content={data.metaDescription} />
        <link rel="canonical" href={data.canonical} />
      </Helmet>
      <Navbar addSearch={false} hideAlohadorButtons={true} hideSearchButtons={true} />
      <DestinationPage data={data} />
      <Footer />
    </div>
  );
};

export default DestinationContainer;
